import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DashboardInfoTypes, DashboardTypes } from 'features/Codes'
import Tree from 'features/dashboard/tree/Tree'
import DashboardTitle from 'features/dashboard/DashboardTitle'
import DashboardTab from 'features/dashboard/tab/DashboardTab'
import CampaignTable from 'features/dashboard/table/campaign/CampaignTable'
import AdGroupTable from 'features/dashboard/table/adGroup/AdGroupTable'
import KeywordTable from 'features/dashboard/table/keyword/KeywordTable'
import CreativeTable from 'features/dashboard/table/creative/CreativeTable'
import Info from 'features/dashboard/info/Info'
import { initialize } from 'features/dashboard/dashboardCommonSlice'
import Loading from 'components/loading/Loading'
import classNames from 'classnames'
import CampaignConversionTrackingEditModal from 'features/dashboard/operation/campaignConversionTrackingEdit/CampaignConversionTrackingEditModal'
import CampaignTraceUrlEditModal from 'features/dashboard/operation/campaignTraceUrlEdit/CampaignTraceUrlEditModal'
import CampaignDailyBudgetEditModal from 'features/dashboard/operation/campaignDailyBudgetEdit/CampaignDailyBudgetEditModal'
import AdGroupMaxBiddingAmountEditModal from 'features/dashboard/operation/adGroupMaxBiddingAmountEdit/AdGroupMaxBiddingAmountEditModal'
import AdGroupContentMatchingMaxBiddingAmountEditModal from 'features/dashboard/operation/adGroupContentMatchingMaxBiddingAmountEdit/AdGroupContentMatchingMaxBiddingAmountEditModal'
import AdGroupWeightEditModal from 'features/dashboard/operation/adGroupWeightEdit/AdGroupWeightEditModal'
import AdGroupDailyBudgetEditModal from 'features/dashboard/operation/adGroupDailyBudgetEdit/AdGroupDailyBudgetEditModal'
import AdGroupDeviceEditModal from 'features/dashboard/operation/adGroupDeviceEdit/AdGroupDeviceEditModal'
import AdGroupPlacementEditModal from 'features/dashboard/operation/adGroupPlacementEdit/AdGroupPlacementEditModal'
import AdGroupDurationEditModal from 'features/dashboard/operation/adGroupDurationEdit/AdGroupDurationEditModal'
import AdGroupWeeklyScheduleEditModal from 'features/dashboard/operation/adGroupWeeklyScheduleEdit/AdGroupWeeklyScheduleEditModal'
import AdGroupKeywordExtensionEditModal from 'features/dashboard/operation/adGroupKeywordExtensionEdit/AdGroupKeywordExtensionEditModal'
import KeywordExposurePreviewModal from 'features/dashboard/operation/keywordExposurePreview/KeywordExposurePreviewModal'
import KeywordBiddingStrategyEditModal from 'features/dashboard/operation/keywordBiddingStrategyEdit/KeywordBiddingStrategyEditModal'
import KeywordLandingUrlEditModal from 'features/dashboard/operation/keywordLandingUrlEdit/KeywordLandingUrlEditModal'
import CreativePreviewModal from 'features/dashboard/operation/creativePreview/CreativePreviewModal'
import ReviewReasonModal from '../reviewReason/ReviewReasonModal'

const DashboardTables = {
  [DashboardTypes.CAMPAIGN]: CampaignTable,
  [DashboardTypes.AD_GROUP]: AdGroupTable,
  [DashboardTypes.KEYWORD]: KeywordTable,
  [DashboardTypes.CREATIVE]: CreativeTable,
}

const Dashboard = () => {
  const dispatch = useDispatch()
  const {
    common: { type, isLoading },
    tree: { visible },
    info: { type: infoType },
  } = useSelector(state => state.dashboard)
  const Table = DashboardTables[type]

  useEffect(() => {
    dispatch(initialize())
  }, [dispatch])

  return (
    <>
      <h2 id="kakaoBody" className="screen_out">
        광고그룹 대시보드 본문
      </h2>
      <div
        id="dashboardWrap"
        className={classNames('dashboard_wrap', { list_on: visible })}>
        <DashboardTitle />
        <Tree />
        <div className="dashboard_box">
          <Info />
          <DashboardTab />
          {isLoading ? <Loading /> : <Table />}
        </div>
      </div>
      {(type === DashboardTypes.CAMPAIGN ||
        infoType === DashboardInfoTypes.CAMPAIGN) && (
        <>
          <CampaignConversionTrackingEditModal />
          <CampaignTraceUrlEditModal />
          <CampaignDailyBudgetEditModal />
        </>
      )}
      {(type === DashboardTypes.AD_GROUP ||
        infoType === DashboardInfoTypes.AD_GROUP) && (
        <>
          <AdGroupMaxBiddingAmountEditModal />
          <AdGroupContentMatchingMaxBiddingAmountEditModal />
          <AdGroupWeightEditModal />
          <AdGroupDailyBudgetEditModal />
          <AdGroupDeviceEditModal />
          <AdGroupPlacementEditModal />
          <AdGroupDurationEditModal />
          <AdGroupWeeklyScheduleEditModal />
          <AdGroupKeywordExtensionEditModal />
        </>
      )}
      {(type === DashboardTypes.KEYWORD ||
        infoType === DashboardInfoTypes.KEYWORD) && (
        <>
          <KeywordExposurePreviewModal />
          <KeywordBiddingStrategyEditModal />
          <KeywordLandingUrlEditModal />
          <ReviewReasonModal />
        </>
      )}
      {(type === DashboardTypes.CREATIVE ||
        infoType === DashboardInfoTypes.CREATIVE) && (
        <>
          <CreativePreviewModal />
          <ReviewReasonModal />
        </>
      )}
    </>
  )
}
export default Dashboard
